module.exports = __webpack_public_path__ + "assets/b293c2b9453e1ada2605e734c3901607.svg";